<template>
  <div
    @click="goDetail(courseInfo.id)"
    class="course-card"
    :class="{
      'h5-course-card': isH5 && needAdaptStyle,
      'electron-course-card': isElectron && needAdaptStyle,
      'pc-course-card': !isH5 && !isElectron,
    }"
  >
    <div class="cover-wrap">
      <img
        class="cover"
        :src="courseInfo.cover_url + '?imageView2/0/w/560'"
        alt=""
      />
      <CourseStatusTag
        :liveState="courseInfo.live_state || 0"
        :trialState="courseInfo.trial_state || 0"
      />
    </div>
    <!-- 课程信息 -->
    <div class="course-info">
      <p class="title">
        <span v-if="courseInfo.category_name" class="course-tag">
          {{ courseInfo.category_name }}</span
        >{{ courseInfo.course_name }}
      </p>
      <div class="bottom-wrap">
        <div v-if="courseInfo.goods" class="price-wrap">
          <!--免费 -->
          <span v-if="courseInfo.goods.fee_type === 1" class="free-price"
            >免费</span
          >
          <Price
            v-else
            :size="priceSize"
            :activePrice="courseInfo.activetyPrice * 100"
            :originPrice="courseInfo.originPrice"
          />
        </div>
        <!-- 营销标识 -->
        <p class="activity-mark" v-if="activityText">{{ activityText }}</p>
      </div>
    </div>
    <div v-if="showOrgInfo" class="card-bottom">
      <!-- 机构信息 -->
      <p class="org-info">
        <img class="logo" :src="handlerOrgLogo()" alt="" />
        <span class="org-name">
          {{ courseInfo.org_name }}
        </span>
      </p>
      <!-- 课时信息 -->
      <p class="data-STATS">
        <span class="lesson">{{ courseInfo.lesson_count }}课时</span>
        <span
          style="display: flex; align-items: center"
          v-if="
            courseInfo.goods && courseInfo.goods.show_enrollment_count === 1
          "
        >
          <span class="separate"></span
          >{{ million(courseInfo.enrollment_count) }}人报名</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import courseCard from "@saas/components/src/mixins/courseCard";
import { isH5, Price, CourseStatusTag, isMobile } from "@saas/components/src";
import { million } from "@saas/components/src/utils/utils";
export default {
  mixins: [courseCard],
  props: {
    // groupInfo: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // },
    courseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    orgInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showOrgInfo: {
      type: Boolean,
      default: true,
    },
    needAdaptStyle: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      million,
      isH5: isH5(),
      isMobile: isMobile(),
      isElectron: window.isElectron,
    };
  },
  methods: {
    goDetail(id) {
      let url = `/product-detail/${id}`;
      if (this.iosInReview) {
        this.$router.push(`${url}?inReview=1`);
      } else if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    handlerOrgLogo() {
      if (!this.orgInfo?.org_logo) {
        return `https://cdn.comettech.com/cdn/static/images/default_org_logo.png?imageView2/0/w/100`;
      } else {
        return this.orgInfo.org_logo + "?imageView2/0/w/100";
      }
    },
  },
  created() {
    this.iosInReview = this.$route.query.inReview === "1";
  },
  components: {
    Price,
    CourseStatusTag,
  },
};
</script>

<style lang="scss" scoped>
.course-card {
  &:hover {
    transition: all 0.3s ease;
    transform: translateY(-5px);
    // box-shadow: 0 0 0 12px #fff, 0 3px 24px 0 rgba(102, 116, 107, 0.1);
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    .cover {
      transform: scale(1.2) rotate(0.02deg);
    }
  }
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  width: 282px;
  height: 317px;
  // width: 258px;
  // height: 289px;
  background: #ffffff;
  border-radius: 24px;
  padding: 12px 12px 16px;
  margin-right: 24px;
  margin-bottom: 24px;
  &:nth-child(4n) {
    margin-right: 0;
  }
  display: flex;
  flex-direction: column;
  .cover-wrap {
    width: 258px;
    height: 145px;
    overflow: hidden;
    border-radius: 16px;
    position: relative;
  }
  .cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
    transition: 0.3s ease-in-out;
    will-change: transform;
    transform: scale(1) rotate(0.02deg);
  }
  .course-info {
    width: 100%;
    flex: 1;
    padding: 11px 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      // margin-bottom: 16px;
      .course-tag {
        position: relative;
        top: -1px;
        display: inline-block;
        height: 18px;
        background: #f5f5f5;
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        color: $plain-text-color;
        line-height: 18px;
        text-align: center;
        margin-right: 5px;
        padding: 0 5px;
      }
      font-weight: 500;
      font-size: 18px;
      color: $saas-text-color;
      line-height: 28px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .bottom-wrap {
      display: flex;
      align-items: center;
      .price-wrap {
        // margin-right: 8px;
        .free-price {
          font-weight: 600;
          color: $saas-price-color;
          font-size: 18px;
          line-height: 1;
        }
      }
      .activity-mark {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 16px;
        color: $saas-price-color;
        height: 24px;
        border-radius: 8px;
        border: 1px solid rgba($color: $saas-price-color, $alpha: 0.3);
        padding: 0 2px;
      }
    }
  }
  .card-bottom {
    height: 22px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent;
    .org-info {
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      .logo {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        margin-right: 6px;
        object-fit: cover;
      }
      .org-name {
        flex: 1;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-STATS {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: $saas-text-color;
      line-height: 20px;
      margin-left: 8px;
      .separate {
        display: inline-block;
        width: 1px;
        height: 8px;
        background: #e9e9e9;
        margin: 9px;
      }
    }
  }
}

// 客户端
.course-card.electron-course-card {
  &:nth-child(4n) {
    margin-right: 0;
  }
  width: 230px;
  height: 250px;
  border-radius: 20px;
  padding: 10px 10px 7px;
  margin-right: 20px;
  margin-bottom: 20px;
  .cover-wrap {
    width: 210px;
    border-radius: 13px;
    height: 118px;
    position: relative;
  }
  .course-info {
    padding: 8px 0 13px;
    .title {
      font-weight: 500;
      font-size: 14px;
      color: #0d1400;
      line-height: 22px;
      .course-tag {
        height: 16px;
        border-radius: 3px;
        font-weight: 500;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
        margin-right: 3px;
        padding: 0 2px;
      }
    }
    .bottom-wrap {
      .activity-mark {
        font-size: 10px;
        line-height: 16px;
        height: 18px;
        border-radius: 6px;
        padding: 0 3px;
      }
      .free-price {
        font-size: 16px;
      }
    }
  }
  .card-bottom {
    .org-info {
      .org-name {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
      }
      .logo {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        margin-right: 4px;
      }
    }
    .data-STATS {
      margin-left: 5px;
      font-size: 12px;
      line-height: 16px;
    }
  }
}

// h5
.course-card.h5-course-card {
  &:hover {
    transition: none;
    transform: none;
    .cover {
      transform: none;
    }
  }
  transition: none;
  .cover {
    transition: none;
  }
  &:nth-child(2n) {
    margin-right: 0;
  }
  width: 4.57rem;
  height: 5.35rem;
  padding: 0 0 0.21rem 0;
  border-radius: 0.32rem;
  margin-right: 0.23rem;
  margin-bottom: 0.2rem;
  .cover-wrap {
    width: 4.56rem;
    height: 2.56rem;
    border-radius: 0.32rem 0.32rem 0 0;
    .cover {
      border-radius: 0.32rem 0.32rem 0 0;
    }
  }
  .course-info {
    padding: 0.16rem 0.2rem 0.05rem;
    .title {
      font-weight: 500;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.53rem;
      line-break: anywhere;
      .course-tag {
        height: 0.43rem;
        border-radius: 0.11rem;
        text-align: center;
        margin-right: 3px;
        padding: 0 0.1rem;
        font-weight: 400;
        font-size: 0.29rem;
        color: #515350;
        line-height: 0.48rem;
        position: relative;
        top: -0.03rem;
      }
    }
    .bottom-wrap {
      width: max-content;
      .free-price {
        font-size: 0.37rem;
      }
      .activity-mark {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 0.24rem;
        color: #f03349;
        line-height: 1;
        height: 0.43rem;
        border-radius: 0.11rem;
        padding: 0 0.05rem;
      }
      .price-wrap {
      }
    }
  }
  .card-bottom {
    padding: 0 0.2rem;
    .org-info {
      .org-name {
        font-weight: 400;
        font-size: 0.29rem;
        line-height: 0.4rem;
        color: #515350;
      }
      .logo {
        display: none;
      }
    }
    .data-STATS {
      margin-left: 0.1rem;
      font-weight: 400;
      font-size: 0.29rem;
      color: #515350;
      line-height: 0.4rem;
      .separate {
        margin: 0 0.1rem;
      }
    }
  }
}
</style>
